export const getKey = (): string => {
    return Math.floor(Math.random() * 100000).toString();
};
